import UploadedImage from "./UploadedImage";

export default UploadedImage;
